import { createSlice } from "@reduxjs/toolkit";
import { UserInfoModel } from "../model/ua/user-info";
import { UserMemberModel } from "app/model/ua/UserMemberModel";

const initialState: any = {
  userInfo: UserInfoModel,
  tempUserMemberInfo: UserMemberModel,
  tempMyPageKepcoInfo: UserMemberModel, // 마이페이지 고객정보 수정용!!
  userMemberInfo: UserMemberModel,
  gridData: [],
  formData: [],
  signUpComCd: {
    ComUnit: [],
    EmksCustTpClCd: [],
    EmksEntClCd: [],
    EmksEqpKndCd: [],
    EmksIndsCmplxClCd: [],
    EmksMbrsClCd: [],
    EmksPrtclKndCd: [],
    EmksRe100JoinClCd: [],
    EmksRsrcChgClCd: [],
    MobileNumberPrefix: []
  }
}

const userInfoSlice = createSlice({
  name: 'userInfo',
  initialState,
  reducers: {
    setUserInfo: (state, action) => {
      state.userInfo = action.payload;
    },

    setTempUserMemberInfo: (state, action) => {
      state.tempUserMemberInfo = action.payload;
    },

    setUserMemberInfo: (state, action) => {
      state.userMemberInfo = action.payload;
    },

    setMyPageKepcoInfo: (state, action) => {
      state.tempMyPageKepcoInfo = action.payload;
    },

    setGridData: (state, action) => {
      state.gridData = action.payload;
    },
    setFormData: (state, action) => {
      state.formData = action.payload;
    },

    setSignUpComCd: (state, action) => {
      state.signUpComCd = action.payload;
    },

    clearUserInfo: (state) => {
      state.userInfo = null;
      state.tempUserMemberInfo = null;
      state.userMemberInfo = null;
      state.tempMyPageKepcoInfo = null;
      state.formData = [];
      state.gridData = [];
      state.signUpComCd = null;
    },
  },
});

export default userInfoSlice.reducer;
export const {setFormData ,setGridData,setUserInfo, setUserMemberInfo, clearUserInfo, setTempUserMemberInfo, setSignUpComCd, setMyPageKepcoInfo} = userInfoSlice.actions;